import lazyGettext from 'js-utils/lazy-gettext';
import { PACKAGE_ONE, PACKAGE_THREE, PACKAGE_TWO } from '../../constants/main';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

/**
 * CTAStyle property changes the UI state of CTA action and can have 2 states:
 * 1. STYLE_[style type name] (e.g. STYLE_FILL) - CTA action is enabled and will have the given style.
 * 2. null - CTA action is disabled and is grayed out.
 */
export default {
    [PACKAGE_ONE]: {
        mainHeader: {
            primaryCTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_FILL,
        },
        middleBanner: {
            CTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_NEUTRAL,
        },
        bottomBanner: {
            CTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_NEUTRAL,
        },
    },
    [PACKAGE_TWO]: {
        mainHeader: {
            primaryCTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_FILL,
        },
        middleBanner: {
            CTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_NEUTRAL,
        },
        bottomBanner: {
            CTA: lazyGettext('Contact Us'),
            CTAStyle: STYLE_NEUTRAL,
        },
    },
    [PACKAGE_THREE]: {
        mainHeader: {
            primaryCTA: lazyGettext('Your Current Package'),
            CTAStyle: null,
        },
        middleBanner: {
            CTA: lazyGettext('Your Current Package'),
            CTAStyle: null,
        },
        bottomBanner: {
            CTA: lazyGettext('Your Current Package'),
            CTAStyle: null,
        },
    },
};
